import React from "react"
import AddressDisplay from "./address-display"
import store from "../store"
const CONSTS = require("shared/consts")

export default function StepToTitle({ step, showNames }) {
  store.useRerenderIfChange(() => [step.description])

  const getSender = () => {
    return (
      store.selectedSimulationAddressList[step.from] ||
      `${step.from.substring(0, 7)}...`
    )
  }

  const getArguments = () => {
    if (!step.parameters || !step.parameters.length) {
      return "";
    }
  
    const argumentsArr = step.parameters.map(param => {
      if (store.selectedSimulationAddressList[param]) {
        return store.selectedSimulationAddressList[param];
      } else if (store.selectedSimulationByte32List[param]) {
        const byte32variableName = store.selectedSimulationByte32List[param];
        const byte32shorten = `${param.substring(0, 7)}...${param.substring(param.length - 7)}`;
        return `${byte32variableName}(${byte32shorten})`;
      } else if (param.length > 14) {
        return `${param.substring(0, 7)}...${param.substring(param.length - 7)}`;
      } else {
        return param;
      }
    });
  
    return `(${argumentsArr.join()})`;
  };
  

  return (
    <>
      {step.description ? (
        <>
          <span>{step.description}</span>
          <br />
        </>
      ) : null}
      {step.type == CONSTS.STEP_TYPES.COMPILE_SMART_CONTRACT && (
        <span>
          <AddressDisplay
            disableCopy
            shorten
            address={step.from}
            showNames={showNames}
          />{" "}
          deploy contract {getArguments()}
        </span>
      )}

      {step.type == CONSTS.STEP_TYPES.CHECk_BALANCE && "Check ETH balance"}

      {step.type == CONSTS.STEP_TYPES.ENCODE_TRANSACTION &&
        step.function_name && (
          <span>
            <AddressDisplay
              disableCopy
              shorten
              address={step.from}
              showNames={showNames}
            />
            &nbsp;
            <span>
              {getSender()}&nbsp;{step.function_name}
              {getArguments()}
            </span>
          </span>
        )}

      {step.type == CONSTS.STEP_TYPES.ENCODE_TRANSACTION &&
        step.abi &&
        !step.function_name &&
        "Choose a function"}
      {step.type == CONSTS.STEP_TYPES.ENCODE_TRANSACTION &&
        !step.abi &&
        !step.function_name &&
        "Enter contract address"}
    </>
  )
}
